// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c6facdee","802":"87cac17d"}[chunkId] + ".chunk.js";
};